import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { putNewVenue } from '@/api/venueService';

import {
  OPEN_SAVE_FAIL_POPUP,
  CLOSE_SAVE_FAIL_POPUP,
} from '@/store/actions/apiFailPopupAction';

import {
  FETCH_VENUE_EQUIPMENTS,
  FETCH_VENUE_TYPE_OPTIONS,
  FETCH_VENUE_CHARACTERISTICS,
} from '@/store/actions/srpOptionsAction';

import MainContent from '@/component-style/MainContent';
import PanelVenueDetail from '@/components/Panel/PanelVenueDetail';
import PopupLoading from '@/components/UI/Popup/PopupLoading';
import PopupExecuteResult from '@/components/UI/Popup/PopupExecuteResult';
import { ButtonBasic, ButtonCancel } from '@/component-style/Button';
import { DivFlexRow } from '@/component-style/RWDWrapper';


import { venueConfig } from '@/constant/dataConfig/informationModule';
import { integerConverter, floatConverter } from '@/utils/textUtils';

const DivButtonsWrapper = styled(DivFlexRow)`
  max-width: 1535px;
  padding-right: 0;
  padding-left: 135px;
  padding-bottom: 30px;
  justify-content: space-between;

  @media (max-width: 425px) {
    justify-content: center;
    padding-left: 0;
  }
`;

const ButtonSave = styled(ButtonBasic)`
  width: 120px;
  margin-right: 10px;
  margin-bottom: 10px;
`;

const ButtonClear = styled(ButtonCancel)`
  width: 120px;
  margin-bottom: 10px;
`;

const VenueCreation = props => {
  const dispatch = useDispatch();
  const history = useHistory();
  const venueEquipments = useSelector(state => state.srpOptions.venueEquipments);
  const venueTypeOptions = useSelector(state => state.srpOptions.venueTypeOptions);
  const venueCharacteristics = useSelector(state => state.srpOptions.venueCharacteristics);
  const showSaveFailPopup = useSelector(state => state.apiFail.showSaveFailPopup);
  const apiFailPopupTitle = useSelector(state => state.apiFail.title);
  const apiFailPopupMessage = useSelector(state => state.apiFail.message);

  const [venue, setVenue] = useState({
    ...venueConfig,
    fees: { ...venueConfig.fees },
    capacity: { ...venueConfig.capacity },
    spaceInfo: { ...venueConfig.spaceInfo },
    basicInfo: {
      ...venueConfig.basicInfo,
      equipments: [],
      characteristics: [],
    },
  });

  const [showLoadingPopup, setShowLoadingPopup] = useState(false);
  const [showSaveSuccessPopup, setShowSaveSuccessPopup] = useState(false);

  const updateVenueHandler = (key, value) => {
    const updateObj = { ...venue };
    updateObj[key] = value;
    setVenue({ ...updateObj });
  };

  const clearData = () => {
    setVenue({
      ...venueConfig,
      fees: { ...venueConfig.fees },
      capacity: { ...venueConfig.capacity },
      spaceInfo: { ...venueConfig.spaceInfo },
      basicInfo: {
        ...venueConfig.basicInfo,
        equipments: [],
        characteristics: [],
      },
    });
  };

  const closeSuccessPopupHandler = () => {
    clearData();
    setShowSaveSuccessPopup(false);
  }

  const saveNewVenueHandler = async () => {
    setShowLoadingPopup(true);

    try {
      await putNewVenue({
        ...venue,
        spaceInfo: {
          ...venue.spaceInfo,
          size: floatConverter(venue.spaceInfo.size),
        },
        capacity: {
          total: integerConverter(venue.capacity.total),
          theater: integerConverter(venue.capacity.theater),
          horseshoe: integerConverter(venue.capacity.horseshoe),
          cocktailParty: integerConverter(venue.capacity.cocktailParty),
          roundTable: integerConverter(venue.capacity.roundTable),
          smalllRoundTable: integerConverter(venue.capacity.smalllRoundTable),
          classroom: integerConverter(venue.capacity.classroom),
          square: integerConverter(venue.capacity.square),
        },
      });
      setShowLoadingPopup(false);
      setShowSaveSuccessPopup(true);
    } catch (err) {
      setShowLoadingPopup(false);
      dispatch(OPEN_SAVE_FAIL_POPUP({ title: '刪除失敗', err }));
      console.log(err);
    }
  };

  const initOptions = useCallback(() => {
    dispatch(FETCH_VENUE_EQUIPMENTS({ enable: true }));
    dispatch(FETCH_VENUE_TYPE_OPTIONS({ enable: true }));
    dispatch(FETCH_VENUE_CHARACTERISTICS({ enable: true }));
  }, [dispatch]);

  useEffect(() => {
    initOptions();
  }, [initOptions]);

  return (
    <MainContent>
      <PanelVenueDetail
        title = "新增場地資料"
        venue = { venue }
        venueEquipments = { venueEquipments }
        venueTypeOptions = { venueTypeOptions }
        venueCharacteristics = { venueCharacteristics }
        updateVenueHandler = { updateVenueHandler }
      >
      {
        <DivFlexRow>
          <DivButtonsWrapper>
            <div>
              <ButtonSave
                onClick = { saveNewVenueHandler }
              >儲存</ButtonSave>
              <ButtonClear
                onClick = { clearData }
              >清除欄位</ButtonClear>
            </div>
            <ButtonClear
              onClick = { () => { history.goBack() } }
            >離開</ButtonClear>
          </DivButtonsWrapper>
        </DivFlexRow>
      }
      </PanelVenueDetail>
      { showLoadingPopup && <PopupLoading/> }
      {
        showSaveSuccessPopup &&
          <PopupExecuteResult
            title = "儲存成功"
            confirmHandler = { closeSuccessPopupHandler }
          />
      }
      {
        showSaveFailPopup &&
          <PopupExecuteResult
            title = { apiFailPopupTitle }
            text = { apiFailPopupMessage }
            confirmHandler = { () => {
              dispatch(CLOSE_SAVE_FAIL_POPUP());
            }}
          />
      }
    </MainContent>
  )
};

export default VenueCreation;
